// src/utils/carteleria/pantallasVigentesMotor.js
//
// F3d: pantallas de cartelería vigentes a una fecha (licencias OnSign de `proveedoresRecurrentes`) leídas del motor
// `calendarioNegocio` para fechas >= CORTE_HISTORICO (2026-10-01). La fecha es el último día del mes consultado:
// una fila cuenta si ese mes cae dentro de la ventana de servicio del motor (`mesesVentana`: fin de contrato por
// plazo o `fecha_fin`, y "el estado manda": un activo vencido sigue hasta el mes actual). Se conservan los filtros
// del código anterior: sin `cantidad_pantallas` no cuenta, y un negocio sin plazo (ni `fecha_fin`) cuenta siempre.
import { calendarioNegocio } from "./calendarioNegocio";

export const contarPantallasNegociosMotor = (negocios, fecha, hoy) => {
  const [y, m] = String(fecha).split("-").map(Number);
  let total = 0;
  for (const n of negocios || []) {
    if (!n.cantidad_pantallas) continue;
    const cal = calendarioNegocio(n, { hoy });
    if (!cal.elegible) continue;
    if (!(n.plazo_contrato_meses || n.fecha_fin) || !n.fecha_inicio) {
      total += cal.pantallas;
      continue;
    }
    const [y0, m0] = String(n.fecha_inicio).split("-").map(Number);
    const k = (y - y0) * 12 + (m - m0);
    if (k >= 0 && k < cal.mesesVentana) total += cal.pantallas;
  }
  return total;
};
